import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-files-deleted-folder-icon',
  templateUrl: './files-deleted-folder.component.html'
})
export class FilesDeletedFolderComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
